import { gql } from '@apollo/client'

export const CUSTOMER_ADDRESS_FRAGMENT = gql`
  fragment CustomerAddress on CustomerAddress {
    address1
    address2
    city
    country
    countryIsoCode
    firstName
    lastName
    stateIsoCode
    zipCode
    id
    latitude
    longitude
    cityGooglePlaceId
    primary
  }
`
